module.exports = __webpack_public_path__ + "static/media/zea_mays.flower_parts.3f037101.svg";